const translations = {
    firstNameFieldLabel: 'FIRST NAME PLEASE'
};

export default translations;
